import React, {useEffect} from 'react'
import {BrowserRouter as Router} from 'react-router-dom'
import {AuthContext} from './context/AuthContext'
import {useAuth} from './hooks/auth.hook'
import {useRoutes} from './routes'
import ReactGA from 'react-ga'
import {createBrowserHistory} from 'history'
import {YMInitializer} from 'react-yandex-metrika'
import {AllErrorsBoundary} from "./containers/Errors";

/**
 Google аналитика.
 * @function ReactGA
 * @param {string} trackId
 */
ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTIC, {debug: false})
const browserHistory = createBrowserHistory()
browserHistory.listen((location, action) => {
    ReactGA.pageview(location.pathname + location.search)
})


function App() {

    const {token, login, logout, userId, roleId, loginWithoutRemember, userName} = useAuth()
    const isAuthenticated = !!token
    const routes = useRoutes(isAuthenticated, roleId) // Инициализация роутов

    useEffect(() => {
        ReactGA.pageview(window.location.pathname + window.location.search) // Google Аналитика
    }, [])


    return (
        <AllErrorsBoundary>

            <AuthContext.Provider
                value={{token, login, logout, roleId, userId, userName, loginWithoutRemember, isAuthenticated}}>
                <React.Fragment>

                    <Router>
                        {/* Yandex аналитика */}

                        <YMInitializer version={"2"}
                                       accounts={[process.env.REACT_APP_YANDEX_ANALYTIC]}
                                       options={{
                                           clickmap: true,
                                           trackLinks: true,
                                           accurateTrackBounce: true,
                                           webvisor: true
                                       }}/>
                        {routes}
                    </Router>
                </React.Fragment>

            </AuthContext.Provider>
        </AllErrorsBoundary>

    );
}

export default App
